import { render, staticRenderFns } from "./ViewCustomer.vue?vue&type=template&id=01ea9153&scoped=true&"
import script from "./ViewCustomer.vue?vue&type=script&lang=js&"
export * from "./ViewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ViewCustomer.vue?vue&type=style&index=0&id=01ea9153&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ea9153",
  null
  
)

export default component.exports